import Tooltip, { TooltipProps, TOP_TIP_POSITION, ToolTipWrapper } from './Tooltip'

export default Tooltip

export { Tooltip, TooltipProps, ToolTipWrapper, TOP_TIP_POSITION }
